export const ADD_TO_BAG_EVENTS = {
  CLICKED: 'move-to-bag-clicked',
  POPUP_VISIBLE: 'wishlist-action-popup',
  POPUP_CLOSED: 'wishlist-size-popup-closed',
  SIZE_SELECTED: 'wishlist-size-selected',
};
